<mat-form-field
  class="w-full"
  [appearance]="appearance()"
  [ngClass]="{ compact: compact() }"
>
  <mat-label>{{ label() }}</mat-label>

  <span matSuffix class="mr-2" (click)="$event.stopPropagation()">
    <pr-tag-filter
      [tags]="availableTags$ | async"
      [selectedTags]="selectedTagRefs()"
      [disabled]="disabled()"
      (click)="$event.stopPropagation()"
      (selectionChange)="tagsChanged($event)"
    />
  </span>

  <input
    matInput
    [formControl]="searchCtrl"
    [matAutocomplete]="contactAutocomplete"
    [disabled]="disabled()"
    [placeholder]="label()"
    [ngClass]="{ 'text-xs': compact() }"
  />

  <button
    type="button"
    matIconSuffix
    mat-icon-button
    [disabled]="searchCtrl.disabled"
    (click)="clear()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete
    #contactAutocomplete="matAutocomplete"
    [autoActiveFirstOption]="true"
    [displayWith]="displayFn"
    (optionSelected)="optionSelected($event.option.value)"
  >
    @for (contact of search.results$ | async; track contact.ref.path) {
      <mat-option [value]="contact">
        {{ contact.name }}
      </mat-option>
    } @empty {
      <mat-option disabled>
        <span>No contacts found for "{{ searchCtrl.value }}"</span>
        @if (selectedTags().length) {
          <span> with selected tags</span>
          <div class="flex flex-wrap gap-1">
            @for (tag of selectedTags(); track tag.ref.path) {
              <mat-chip
                disableRipple
                [style.--mdc-chip-label-text-color]="tag | tagTextColour"
                [style.background-color]="tag.hexColour"
              >
                {{ tag.name }}
              </mat-chip>
            }
          </div>
        }
      </mat-option>
    }
  </mat-autocomplete>
  <mat-hint class="flex" align="end">
    <a class="flex items-center" [routerLink]="[]" (click)="manageContact()">
      @if (selectedContact()) {
        <mat-icon>edit</mat-icon> Edit Contact
      } @else {
        <mat-icon>add</mat-icon> Create Contact
      }
    </a>
  </mat-hint>
</mat-form-field>
